// Mock data representing the DynamoDB tables and S3 metadata.
// Replace these with real API calls once the backend is deployed.

// ── Segments ──────────────────────────────────────────────────────────────────
export const MOCK_SEGMENTS = [
  { id: "seg-001", name: "All Clinicians", deviceCount: 9800, createdAt: "2026-01-10T08:00:00Z" },
  { id: "seg-002", name: "Canary Fleet (5%)", deviceCount: 500, createdAt: "2026-01-10T08:00:00Z" },
  { id: "seg-003", name: "ICU Units", deviceCount: 1200, createdAt: "2026-02-01T09:00:00Z" },
  { id: "seg-004", name: "Technicians", deviceCount: 150, createdAt: "2026-01-10T08:00:00Z" },
];

// ── Firmware Baselines ─────────────────────────────────────────────────────────
// States: DRAFT → SIGNED → PUBLISHED → DEPRECATED
export const MOCK_BASELINES = [
  {
    id: "fw-007",
    version: "1.6.0-beta",
    filename: "tetra-firmware-1.6.0-beta.bin",
    size: 16886579,
    sha256: "a3f7c1d8e2b4f6a1c3d5e7b2f4a6c8d1e3f5a7b2c4d6e8f1a3b5c7d9e2f4a6c8",
    state: "SIGNED",
    mandatory: false,
    releaseNotes: "Beta release — new infusion rate algorithm. Requires hardware rev B or later.",
    uploadedBy: "r.manager@emedtc.com",
    uploadedAt: "2026-04-25T14:30:00Z",
    approvedBy: "admin@emedtc.com",
    approvedAt: "2026-04-25T16:00:00Z",
    publishedAt: null,
    targetSegment: null,
    targetSegmentName: null,
    devicesUpToDate: 0,
    totalDevices: 247,
  },
  {
    id: "fw-005",
    version: "1.5.0",
    filename: "tetra-firmware-1.5.0.bin",
    size: 14889779,
    sha256: "b8e2a4f1c3d5e7b2f4a6c8d1e3f5a7b2c4d6e8f1a3b5c7d9e2f4a6c8d1e3f5a7",
    state: "PUBLISHED",
    mandatory: true,
    releaseNotes: "Improves BLE chunk transfer reliability. Addresses HASH_MISMATCH under high RF noise. Minimum firmware to upgrade from: 1.4.0.",
    uploadedBy: "r.manager@emedtc.com",
    uploadedAt: "2026-04-14T09:00:00Z",
    approvedBy: "admin@emedtc.com",
    approvedAt: "2026-04-14T10:00:00Z",
    publishedAt: "2026-04-15T09:14:00Z",
    targetSegment: "seg-001",
    targetSegmentName: "All Clinicians",
    devicesUpToDate: 209,
    totalDevices: 247,
  },
  {
    id: "fw-004",
    version: "1.4.2",
    filename: "tetra-firmware-1.4.2.bin",
    size: 14470349,
    sha256: "c9d3b5e2f4a6c8d1e3f5a7b2c4d6e8f1a3b5c7d9e2f4a6c8d1e3f5a7b2c4d6e8",
    state: "PUBLISHED",
    mandatory: false,
    releaseNotes: "Minor stability improvements. BLE stack update.",
    uploadedBy: "r.manager@emedtc.com",
    uploadedAt: "2026-02-27T09:00:00Z",
    approvedBy: "admin@emedtc.com",
    approvedAt: "2026-02-27T10:00:00Z",
    publishedAt: "2026-02-28T14:30:00Z",
    targetSegment: "seg-001",
    targetSegmentName: "All Clinicians",
    devicesUpToDate: 38,
    totalDevices: 247,
  },
  {
    id: "fw-003",
    version: "1.4.0",
    filename: "tetra-firmware-1.4.0.bin",
    size: 13840179,
    sha256: "d1a6c3b8e2f4a6c8d1e3f5a7b2c4d6e8f1a3b5c7d9e2f4a6c8d1e3f5a7b2c4d6",
    state: "DEPRECATED",
    mandatory: false,
    releaseNotes: "Baseline 1.4.0 — superseded by 1.4.2.",
    uploadedBy: "r.manager@emedtc.com",
    uploadedAt: "2025-11-09T09:00:00Z",
    approvedBy: "admin@emedtc.com",
    approvedAt: "2025-11-09T10:00:00Z",
    publishedAt: "2025-11-10T11:45:00Z",
    targetSegment: "seg-001",
    targetSegmentName: "All Clinicians",
    devicesUpToDate: 0,
    totalDevices: 247,
  },
  {
    id: "fw-002",
    version: "1.3.1",
    filename: "tetra-firmware-1.3.1.bin",
    size: 13528269,
    sha256: "e2b5d4a7c1f3e5b7d9f2a4c6e8b1d3f5a7c9e2b4d6f8a1c3e5b7d9f2a4c6e8b1",
    state: "DEPRECATED",
    mandatory: false,
    releaseNotes: "Baseline 1.3.1 — superseded by 1.4.0.",
    uploadedBy: "r.manager@emedtc.com",
    uploadedAt: "2025-08-02T09:00:00Z",
    approvedBy: "admin@emedtc.com",
    approvedAt: "2025-08-02T10:00:00Z",
    publishedAt: "2025-08-03T16:20:00Z",
    targetSegment: "seg-001",
    targetSegmentName: "All Clinicians",
    devicesUpToDate: 0,
    totalDevices: 247,
  },
  {
    id: "fw-001",
    version: "1.3.0",
    filename: "tetra-firmware-1.3.0.bin",
    size: 13107200,
    sha256: "f3c6e1a8d2f4b6e8a1c3e5b7d9f2a4c6e8b1d3f5a7c9e2b4d6f8a1c3e5b7d9f2",
    state: "DEPRECATED",
    mandatory: false,
    releaseNotes: "Initial production release.",
    uploadedBy: "r.manager@emedtc.com",
    uploadedAt: "2025-05-01T09:00:00Z",
    approvedBy: "admin@emedtc.com",
    approvedAt: "2025-05-01T10:00:00Z",
    publishedAt: "2025-05-02T10:00:00Z",
    targetSegment: "seg-001",
    targetSegmentName: "All Clinicians",
    devicesUpToDate: 0,
    totalDevices: 247,
  },
  {
    id: "fw-006",
    version: "1.6.0-rc1",
    filename: "tetra-firmware-1.6.0-rc1.bin",
    size: 16515072,
    sha256: "a9f2c5d8b1e4a7c3f6e9b2d5f8a1c4e7b3d6f9a2c5e8b1d4f7a3c6e9b2d5f8a1",
    state: "SIGNED",
    mandatory: false,
    releaseNotes: "RC1 for v1.6.0 — pending canary sign-off.",
    uploadedBy: "r.manager@emedtc.com",
    uploadedAt: "2026-04-22T11:00:00Z",
    approvedBy: "admin@emedtc.com",
    approvedAt: "2026-04-22T13:00:00Z",
    publishedAt: null,
    targetSegment: "seg-002",
    targetSegmentName: "Canary Fleet (5%)",
    devicesUpToDate: 0,
    totalDevices: 247,
  },
];

// ── Rollouts ───────────────────────────────────────────────────────────────────
export const MOCK_ROLLOUTS = [
  {
    id: "ro-001",
    baselineId: "fw-003",
    baselineVersion: "2.1.4",
    state: "PHASE_100",
    targetSegment: "seg-001",
    targetSegmentName: "All Clinicians",
    targetCount: 9800,
    successCount: 9421,
    rollbackCount: 12,
    pendingCount: 367,
    rollbackRate: 0.00127,
    rollbackRateThreshold: 0.05,
    phases: [
      { label: "Canary (5%)", targetPct: 5, successCount: 490, rollbackCount: 2, state: "COMPLETE" },
      { label: "Phase 25%", targetPct: 25, successCount: 2450, rollbackCount: 5, state: "COMPLETE" },
      { label: "Phase 100%", targetPct: 100, successCount: 6481, rollbackCount: 5, state: "IN_PROGRESS" },
    ],
    startedAt: "2026-04-21T11:00:00Z",
    updatedAt: "2026-04-27T08:45:00Z",
    pausedAt: null,
    completedAt: null,
  },
  {
    id: "ro-002",
    baselineId: "fw-002",
    baselineVersion: "2.0.1",
    state: "COMPLETE",
    targetSegment: "seg-001",
    targetSegmentName: "All Clinicians",
    targetCount: 9200,
    successCount: 9187,
    rollbackCount: 13,
    pendingCount: 0,
    rollbackRate: 0.00141,
    rollbackRateThreshold: 0.05,
    phases: [
      { label: "Canary (5%)", targetPct: 5, successCount: 460, rollbackCount: 3, state: "COMPLETE" },
      { label: "Phase 25%", targetPct: 25, successCount: 2300, rollbackCount: 5, state: "COMPLETE" },
      { label: "Phase 100%", targetPct: 100, successCount: 6427, rollbackCount: 5, state: "COMPLETE" },
    ],
    startedAt: "2026-03-02T08:00:00Z",
    updatedAt: "2026-03-10T12:00:00Z",
    pausedAt: null,
    completedAt: "2026-03-10T12:00:00Z",
  },
  {
    id: "ro-003",
    baselineId: "fw-005",
    baselineVersion: "2.2.0-rc1",
    state: "CANARY",
    targetSegment: "seg-002",
    targetSegmentName: "Canary Fleet (5%)",
    targetCount: 500,
    successCount: 12,
    rollbackCount: 1,
    pendingCount: 487,
    rollbackRate: 0.077,
    rollbackRateThreshold: 0.05,
    phases: [
      { label: "Canary (5%)", targetPct: 5, successCount: 12, rollbackCount: 1, state: "PAUSED" },
      { label: "Phase 25%", targetPct: 25, successCount: 0, rollbackCount: 0, state: "PENDING" },
      { label: "Phase 100%", targetPct: 100, successCount: 0, rollbackCount: 0, state: "PENDING" },
    ],
    startedAt: "2026-04-26T12:00:00Z",
    updatedAt: "2026-04-26T13:10:00Z",
    pausedAt: "2026-04-26T13:10:00Z",
    completedAt: null,
  },
];

// ── Devices ────────────────────────────────────────────────────────────────────
export const MOCK_DEVICES = [
  { id: "dev-001", serial: "T-2039", model: "MasterHub v2", currentFw: "v1.4.2", requiredFw: "v1.5.0", status: "MANDATORY",       lastUpdated: "2026-01-14T09:22:00Z", segment: "seg-001", segmentName: "All Clinicians" },
  { id: "dev-002", serial: "T-2041", model: "MasterHub v2", currentFw: "v1.5.0", requiredFw: "v1.5.0", status: "UP_TO_DATE",      lastUpdated: "2026-04-18T14:07:00Z", segment: "seg-001", segmentName: "All Clinicians" },
  { id: "dev-003", serial: "T-2044", model: "MasterHub v2", currentFw: "v1.4.2", requiredFw: "v1.5.0", status: "MANDATORY",       lastUpdated: "2026-01-09T11:00:00Z", segment: "seg-001", segmentName: "All Clinicians" },
  { id: "dev-004", serial: "T-2047", model: "MasterHub v1", currentFw: "v1.4.0", requiredFw: "v1.5.0", status: "FAILED_ROLLBACK", lastUpdated: "2025-11-30T08:45:00Z", segment: "seg-001", segmentName: "All Clinicians" },
  { id: "dev-005", serial: "T-2051", model: "MasterHub v2", currentFw: "v1.4.2", requiredFw: "v1.5.0", status: "PENDING",         lastUpdated: "2026-02-01T16:32:00Z", segment: "seg-001", segmentName: "All Clinicians" },
  { id: "dev-006", serial: "T-2055", model: "MasterHub v2", currentFw: "v1.5.0", requiredFw: "v1.5.0", status: "UP_TO_DATE",      lastUpdated: "2026-04-20T10:15:00Z", segment: "seg-001", segmentName: "All Clinicians" },
];

// ── Telemetry ──────────────────────────────────────────────────────────────────
export const MOCK_TELEMETRY = [
  { id: "tel-001", deviceSerial: "T-2041", baselineVersion: "2.1.4", outcome: "SUCCESS", errorCode: null, sessionId: "5e8f1a2b-0001-0000-0000-000000000001", reportedAt: "2026-04-27T08:55:00Z", rolloutId: "ro-001" },
  { id: "tel-002", deviceSerial: "T-2043", baselineVersion: "2.1.4", outcome: "SUCCESS", errorCode: null, sessionId: "5e8f1a2b-0001-0000-0000-000000000002", reportedAt: "2026-04-27T09:01:00Z", rolloutId: "ro-001" },
  { id: "tel-003", deviceSerial: "T-2044", baselineVersion: "2.1.4", outcome: "ROLLBACK", errorCode: "BLE_TIMEOUT", sessionId: "5e8f1a2b-0001-0000-0000-000000000003", reportedAt: "2026-04-27T07:32:00Z", rolloutId: "ro-001" },
  { id: "tel-004", deviceSerial: "T-0011", baselineVersion: "2.2.0-rc1", outcome: "ROLLBACK", errorCode: "HASH_MISMATCH", sessionId: "5e8f1a2b-0003-0000-0000-000000000001", reportedAt: "2026-04-26T13:05:00Z", rolloutId: "ro-003" },
  { id: "tel-005", deviceSerial: "T-0010", baselineVersion: "2.2.0-rc1", outcome: "SUCCESS", errorCode: null, sessionId: "5e8f1a2b-0003-0000-0000-000000000002", reportedAt: "2026-04-26T13:00:00Z", rolloutId: "ro-003" },
  { id: "tel-006", deviceSerial: "T-1001", baselineVersion: "2.1.4", outcome: "SUCCESS", errorCode: null, sessionId: "5e8f1a2b-0001-0000-0000-000000000004", reportedAt: "2026-04-25T10:00:00Z", rolloutId: "ro-001" },
  { id: "tel-007", deviceSerial: "T-1002", baselineVersion: "2.1.4", outcome: "SUCCESS", errorCode: null, sessionId: "5e8f1a2b-0001-0000-0000-000000000005", reportedAt: "2026-04-25T10:05:00Z", rolloutId: "ro-001" },
  { id: "tel-008", deviceSerial: "T-2041", baselineVersion: "2.0.1", outcome: "SUCCESS", errorCode: null, sessionId: "5e8f1a2b-0002-0000-0000-000000000001", reportedAt: "2026-03-05T11:00:00Z", rolloutId: "ro-002" },
];

// ── Audit Log ──────────────────────────────────────────────────────────────────
export const MOCK_AUDIT = [
  { id: "aud-001", action: "BASELINE_PUBLISHED", eventType: "BASELINE_PUBLISH", resource: "fw-003 v2.1.4", actor: "Sarah M.", role: "Release Mgr",     device: "—",    fwVersion: "v1.5.0",          ts: "2026-04-15T09:14:00Z", ip: "10.0.0.4" },
  { id: "aud-002", action: "BASELINE_APPROVED",  eventType: "BASELINE_REVIEW",  resource: "fw-003 v2.1.4", actor: "Sarah M.", role: "Release Mgr",     device: "—",    fwVersion: "v1.5.0",          ts: "2026-04-14T16:45:00Z", ip: "10.0.0.1" },
  { id: "aud-003", action: "BASELINE_UPLOADED",  eventType: "BASELINE_UPLOAD",  resource: "fw-003 v2.1.4", actor: "James R.", role: "Fleet Admin",     device: "—",    fwVersion: "v1.6.0-beta",     ts: "2026-04-28T10:14:00Z", ip: "10.0.0.4" },
  { id: "aud-004", action: "ROLLOUT_PAUSED",      eventType: "OTA_ROLLBACK",     resource: "ro-003",        actor: "TECH-02",  role: "Technician",      device: "T-2047", fwVersion: "v1.4.1→v1.4.0", ts: "2026-04-10T11:30:00Z", ip: "10.0.0.7" },
  { id: "aud-005", action: "OTA_COMPLETE",        eventType: "OTA_COMPLETE",     resource: "ro-001",        actor: "CLIN-07",  role: "Clinician",       device: "T-2041", fwVersion: "v1.5.0",        ts: "2026-04-18T14:07:00Z", ip: "10.0.0.3" },
  { id: "aud-006", action: "BASELINE_UPLOADED",  eventType: "BASELINE_UPLOAD",  resource: "fw-005 v2.2.0-rc1", actor: "James R.", role: "Fleet Admin", device: "—",    fwVersion: "v2.2.0-rc1",      ts: "2026-04-26T09:00:00Z", ip: "10.0.0.4" },
  { id: "aud-007", action: "BASELINE_APPROVED",  eventType: "BASELINE_REVIEW",  resource: "fw-005 v2.2.0-rc1", actor: "Sarah M.", role: "Release Mgr", device: "—",    fwVersion: "v2.2.0-rc1",      ts: "2026-04-26T11:00:00Z", ip: "10.0.0.1" },
  { id: "aud-008", action: "ROLLOUT_STARTED",    eventType: "BASELINE_PUBLISH", resource: "ro-003",        actor: "Sarah M.", role: "Release Mgr",     device: "—",    fwVersion: "v2.2.0-rc1",      ts: "2026-04-26T12:00:00Z", ip: "10.0.0.4" },
];

// ── Activity Sessions: Clients ─────────────────────────────────────────────────
export const MOCK_CLIENTS = [
  { id: "CLIN-07", role: "Clinician", logCount: 62, devicesTouched: 3, alarmsHandled: 2, pending: true },
  { id: "CLIN-04", role: "Clinician", logCount: 48, devicesTouched: 2, alarmsHandled: 0, pending: true },
  { id: "CLIN-11", role: "Clinician", logCount: 37, devicesTouched: 4, alarmsHandled: 1, pending: false },
  { id: "CLIN-02", role: "Clinician", logCount: 55, devicesTouched: 2, alarmsHandled: 1, pending: true },
  { id: "CLIN-09", role: "Clinician", logCount: 21, devicesTouched: 1, alarmsHandled: 0, pending: false },
  { id: "CLIN-14", role: "Clinician", logCount: 44, devicesTouched: 3, alarmsHandled: 2, pending: true },
  { id: "CLIN-06", role: "Clinician", logCount: 33, devicesTouched: 2, alarmsHandled: 0, pending: true },
  { id: "CLIN-10", role: "Clinician", logCount: 19, devicesTouched: 1, alarmsHandled: 0, pending: false },
];

// ── Users ──────────────────────────────────────────────────────────────────────
export const MOCK_USERS = [
  { sub: "sub-001", email: "admin@tetra.med", name: "Alice Admin", role: "FleetAdmin", status: "CONFIRMED", createdAt: "2026-01-01T08:00:00Z", lastLogin: "2026-04-27T08:00:00Z" },
  { sub: "sub-002", email: "r.manager@tetra.med", name: "Robert Manager", role: "ReleaseManager", status: "CONFIRMED", createdAt: "2026-01-05T09:00:00Z", lastLogin: "2026-04-27T08:30:00Z" },
  { sub: "sub-003", email: "support@tetra.med", name: "Sandra Support", role: "SupportEngineer", status: "CONFIRMED", createdAt: "2026-01-05T09:00:00Z", lastLogin: "2026-04-26T16:00:00Z" },
  { sub: "sub-004", email: "support2@tetra.med", name: "Sam Engineer", role: "SupportEngineer", status: "CONFIRMED", createdAt: "2026-02-10T09:00:00Z", lastLogin: "2026-04-25T12:00:00Z" },
  { sub: "sub-005", email: "pending@tetra.med", name: "Pat Pending", role: "ReleaseManager", status: "FORCE_CHANGE_PASSWORD", createdAt: "2026-04-26T14:00:00Z", lastLogin: null },
];
